<template>
    <v-dialog @input="(!$event)? show = false : null"  :value="show" :width="dialogWidth">
        <v-card>
            <v-card-title>
                <span v-if="edit">Edit</span><span v-else>Add</span>&nbsp;Link
            </v-card-title>
            <v-card-text v-if="data">
                <my-form ref="links_form">
                    <v-text-field :rules="[validationRules.required]" label="Link title" v-model="data.title" outlined></v-text-field>
                    <v-text-field :rules="[validationRules.required]" label="Link url" v-model="data.url" outlined></v-text-field>
                </my-form>
                <div class="mt-4">
                    <v-btn class="mr-2" color="red" dark @click="close()">Close</v-btn>
                    <v-btn color="success" dark @click="($refs.links_form.my_validate())? save() : null">Save</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    import Vue from 'vue';
    export default{
        data:() => {
            return{
                show:false,
                edit:false,
                resolve: null,
                reject: null,
                data: null,
            }
        },
        mounted(){
             Vue.prototype.$links = this;
        },
        methods:{
            start(data = {}){
                return new Promise((resolve, reject) => {
                    this.resolve = resolve;
                    this.reject = reject;
                    this.data = data;
                    this.edit = (data.title || data.url) ? true : false;
                    this.show = true;
                })
            },
            close(){
                this.show = false;
                this.data = null;
            },
            save(){
                this.resolve(this.data);
                this.close();
            }
        }
    }
</script>
